<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="orders" :must-sort="true" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.ID }}</td>
                            <td>{{ item.Username }}</td>
                            <td class="text-end font-weight-bold">{{ item.Amount | currency}}</td>
                            <td style="width:500px">{{ item.ComplainText }}</td>
                            <td v-bind:style="{ 'color': get_status_color(item.Status, complain_status_list)}">{{ item.Status | display_value(complain_status_list) }}</td>
                            <td>{{ item.CreatedDate | display_date('DD-MM-YYYY HH:mm:ss')}}</td>
                            <td class="text-center">
                                <v-icon medium class="mr-2" @click="gotoDetail(item.ID, item.UID)">fa-external-link-alt</v-icon>
                                <v-icon medium @click="cancelItem(item.ID)">fa-times-circle</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="dialogNew" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="title">Tạo mới khiếu nại</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg4 md4 sm12>
                <v-text-field label="Mã đơn hàng TQ" v-model="order_cn_code" @keyup.enter="findByOrderCN"></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm12>
                <v-text-field label="Mã đơn hàng" v-model="newComplain.OrderID" readonly></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm12>
                <v-text-field label="Khách hàng" v-model="newComplain.Username" readonly></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12>
                <v-layout row wrap>
                  <v-divider class="ma-0"></v-divider>
                  <v-flex lg4 md4 sm12>
                    <h-currency-input label="Số tiền hoàn (¥)" :decimal="1" v-model="newComplain.AmountNDT" @input="newComplain.Amount = Math.floor(newComplain.AmountNDT * newComplain.ExchangeRate/1000,0)*1000"></h-currency-input>
                  </v-flex>
                  <v-flex lg4 md4 sm12>
                    <h-currency-input label="Tỷ giá tệ" :decimal="0" v-model="newComplain.ExchangeRate" @input="newComplain.Amount = Math.floor(newComplain.AmountNDT * newComplain.ExchangeRate/1000,0)*1000"></h-currency-input>
                  </v-flex>
                  <v-flex lg4 md4 sm12>
                    <h-currency-input label="Tiền hoàn (đ)" :decimal="0" v-model="newComplain.Amount" readonly></h-currency-input>
                  </v-flex>
                  <v-flex lg12 md12 sm12>
                    <v-textarea label="Ghi chú cho khách hàng" v-model="newComplain.ComplainText" class="input-group--focused"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogNew = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="createNewComplain" :disabled="!newComplain.OrderID || order_cn_code == ''">Tạo mới</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "../../configs";
import _ from "lodash";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            search: "",
            headers: [{
                    text: "ID",
                    value: "ID",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Nội dung",
                    value: "ComplainText",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"]
                },                
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    dataType: dataType["Enum"],
                    values: configs.COMPLAIN_STATUS_LIST
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: dataType["Date"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            complain_status_list: configs.COMPLAIN_STATUS_LIST,
            complain_status: configs.COMPLAIN_STATUS,
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "complain_list",
            filterConditions: [],
            quickFilterConditions: [],
            dialogNew: false,
            newComplain: {
                OrderID: 0,
                UID: 0,
                Username: ''
            },
            order_cn_code: ''
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        transactions() {
            if(this.transactions && this.transactions.length > 0) {
                this.newComplain.OrderID = this.transactions[0].OrderID;
                this.newComplain.UID = this.transactions[0].UID;
                this.newComplain.Username = this.transactions[0].Username;
            }
            else {
                sendErrorNotice('Không tìm thấy mã đơn hàng');
            }
        }
    },
    computed: {
        ...mapState({
            orders: state => state.complain.all.data,
            total_rows: state => state.complain.all.total,
            loading: state => state.complain.loading,
            transactions: state => state.orderTransaction.all.data,
        }),
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        csRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("complain/getList", param);
        },
        gotoDetail: function (id, uid) {
            let routeData = this.$router.resolve({
                name: "ComplainDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết khiếu nại (#${id})`
                },
                query: {
                    'uid': uid
                }
            });
            window.open(routeData.href, "_blank");
        },
        cancelItem: function (id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id, `Bạn muốn hủy khiếu nại #${id} ?`);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        createData() {            
            this.dialogNew = true;
        },
        findByOrderCN() {
            var param = {
                filter: [{
                    column: "OrderCodeCN",
                    value: this.order_cn_code.trim(),
                    condition: "s_equal"
                }]
            };
            this.$store.dispatch("orderTransaction/getList", param);
        },
        createNewComplain() {
            if(this.adminRole || this.csRole) {
                this.dialogNew = false;
                this.order_cn_code = '';
                // const cust = _.find(this.customers, {'ID': this.newComplain.UID});
                this.newComplain.ID = 0;
                // this.newComplain.Username = cust.Username;
                this.newComplain.Status = this.adminRole ? this.complain_status.Done : this.complain_status.Processing;
                this.$store.dispatch("complain/setDetail", {...this.newComplain});
                this.newComplain.OrderID = 0;
                this.newComplain.UID = 0;
                this.newComplain.Username = '';
                this.newComplain.AmountNDT = 0;
                this.newComplain.ExchangeRate = 0;
                this.newComplain.Amount = 0;
                this.newComplain.ComplainText = '';
            }
            else {
                sendErrorNotice('Bạn không có quyền xử lý khiếu nại');
            }            
        }
    },
    mounted() {
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
            var updateComplain = {
                "ID": id,
                "Status": this.complain_status.Cancel
            }
            this.$store.dispatch("complain/setDetail", updateComplain);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
